import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';

type RecordStep = '2a' | '2b' | '2c' | 'done';

export default function RecordOnboarding() {
  const [step, setStep] = useState<RecordStep>(() => {
    if (localStorage.getItem('onboardingComplete') === 'true') return 'done';
    if (localStorage.getItem('onboardingStep') !== 'record') return 'done';
    return '2a';
  });

  if (step === 'done') return null;

  const next = () => {
    if (step === '2a') setStep('2b');
    else if (step === '2b') setStep('2c');
    else {
      localStorage.setItem('onboardingComplete', 'true');
      localStorage.removeItem('onboardingStep');
      setStep('done');
    }
  };

  const hints: Record<Exclude<RecordStep, 'done'>, { text: string; position: string }> = {
    '2a': {
      text: 'マイクボタンを押して話してみよう',
      position: 'bottom-[30%]',
    },
    '2b': {
      text: '話すことに困ったらお題をタップ',
      position: 'top-[12%]',
    },
    '2c': {
      text: '話した内容は下に表示されるよ',
      position: 'bottom-[10%]',
    },
  };

  const hint = hints[step];

  return (
    <AnimatePresence>
      <motion.div
        key={step}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] pointer-events-none"
      >
        <div className="absolute inset-0 bg-black/40 pointer-events-auto" onClick={next} />
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className={`absolute ${hint.position} left-0 right-0 flex justify-center z-[101] pointer-events-auto px-6`}
        >
          <div className="bg-card rounded-xl px-5 py-4 shadow-lg max-w-[300px] text-center">
            <p className="text-sm font-medium mb-3">{hint.text}</p>
            <Button size="sm" onClick={next}>
              {step === '2c' ? 'OK' : '次へ'}
            </Button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
